"use strict";

jQuery(document).ready(function($) {

    // Change Cart Quantity
    $(document).on('change', '.QuantityInput', function() {
        // Update Cart.JS
        var id = $(this).attr('data-id');
        var dataToUpdate = {
            updates: {}
        };
        dataToUpdate['updates'][id] = $(this).val();
        var value = $(this).val();
        var parentRow = $(this).parents('.cart__row');

        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: dataToUpdate,
            dataType: 'json',
            success: function(response) {
                console.log('.cart-item-quantity-selector response', response);
                var totalPrice = response.total_price;
                totalPrice = totalPrice / 100;
                $('.cart-grand-total').html(slCurrencySymbol + numberWithCommas(totalPrice.toFixed(2)));

                var items = response.items;
                $.each(items,function(index,item){
                  console.log('item',item.key);

                  var itemPrice =item.line_price;
                  itemPrice = itemPrice / 100;
                  var newSubTotal = slCurrencySymbol + numberWithCommas(itemPrice.toFixed(2));
                  $('[data-key="'+ item.key + '"]').find('.money').html(newSubTotal);
                });

                if (value == 0){
                  parentRow.remove();

                  if (!$('.cart__row').length){
                    location.reload();
                  }
                }

            }
        });

    });

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }



    /*
    * Shipping Protection
    * 2020-04-23
    */
    var shippingProtectionVariantID = 33515590811780;
    var shippingProtection = localStorage.getItem('shipping_protection');
    var shippingProtectStatus = false;
    
    if (!shippingProtection){
        localStorage.setItem('shipping_protection', 'yes');
        shippingProtectStatus = true;
    }else{
        
        if (shippingProtection == 'yes'){
            shippingProtectStatus = true;
        }else{
            shippingProtectStatus = false;
        }

    }
    $('.shipping-protection-checkbox').prop('checked', shippingProtectStatus);


    
        var shippingProtectionPayload = {
            updates: {
                33515590811780: 0
            }
        };
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: shippingProtectionPayload,
          dataType: 'json',
          success: function (response) {

              if (shippingProtectStatus){
            
                console.warn('SP Update.js',response);
  
                console.warn('For Removals - SP Enabled');
                $('.shipping-protection-container').addClass('shipping-protection-on');
      
                // Add Shipping Status to Cart
                var sellingPlansAvailable = [];
                
      
                // Month x Selling Plan ID
                var sellingPlans = [];
                sellingPlans["1"] = 2912878818;
                sellingPlans["2"] = 2912911586;
                sellingPlans["3"] = 2912944354;
                sellingPlans["6"] = 2912977122;
                sellingPlans["12"] = 2913009890;
      
                
                // Selling Plan ID x Month
                var sellingPlansReference = [];
                $.each(sellingPlans,function(index,sellingPlan){
                    sellingPlansReference[sellingPlan] = index;
                });
      
                if (response.items.length){
                    $.each(response.items,function(index,item){
                        //console.log(item);
                        if (item.selling_plan_allocation){
                            var sellingPlan  = item.selling_plan_allocation.selling_plan;
                            console.log(sellingPlan);
      
                            var month = sellingPlansReference[sellingPlan.id];
                            if (!sellingPlansAvailable.includes(month)){
                                sellingPlansAvailable.push(month);
                            }
                        }
                    });
                }
      
                
      
                var shippingProtectionData = {
                    id: shippingProtectionVariantID,
                    quantity: 1
                };
      
                console.warn("For Removals - sellingPlansAvailable",sellingPlansAvailable);
                console.warn("For Removals - shippingProtectionData",shippingProtectionData);
      
                
                if (sellingPlansAvailable.length){
      
                    console.log('sellingPlansAvailable', sellingPlansAvailable);
                    var sellingPlanMonth = Math.min(...sellingPlansAvailable);
      
                    var shippingProtectionSellingPlans = [];
                    shippingProtectionSellingPlans["1"] = 2928410850;
                    shippingProtectionSellingPlans["2"] = 2928443618;
                    shippingProtectionSellingPlans["3"] = 2928476386;
                    shippingProtectionSellingPlans["6"] = 2928509154;
                    shippingProtectionSellingPlans["12"] = 2928541922;
      
                    var sellingPlanID = shippingProtectionSellingPlans[sellingPlanMonth];
      
                    console.log('sellingPlanMonth',sellingPlanMonth);
                    console.log('sellingPlanID',sellingPlanID);
                    shippingProtectionData.selling_plan = sellingPlanID;
      
                }
      
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: shippingProtectionData,
                    dataType: 'json',
                    success: function (response) {
                        console.warn('For Removals - SP Add.js',response);
      
      
                        // // Force 1 Shipping Protection
                        // var shippingProtectionOne = {
                        //     33515590811780: 1
                        // }
                        // var shippingProtectionPayload = {
                        //     updates: shippingProtectionOne
                        // };
                        // $.ajax({
                        //     type: "POST",
                        //     url: "/cart/update.js",
                        //     data: shippingProtectionPayload,
                        //     dataType: 'json',
                        //     success: function (response) {
                        //         console.warn('For Removals - SP Update.js',response);
                        //     }
                        // });
                        
      
      
                    }
      
                });
             }else{
                console.warn('For Removals - SP Disabled');
                $('.shipping-protection-container').removeClass('shipping-protection-on');
            }
          }


      });
     


  
    // if (shippingProtectStatus){
    //     $('.shipping-protection-container').addClass('shipping-protection-on');
    //       var shippingProtectionData = {
    //           id: shippingProtectionVariantID,
    //           quantity: 1
    //       };
    //       $.ajax({
    //           type: "POST",
    //           url: "/cart/add.js",
    //           data: shippingProtectionData,
    //           dataType: 'json',
    //           success: function (response) {
            
    //               // Force 1 Shipping Protection
    //               var shippingProtectionPayload = {
    //                   updates: {
    //                       33515590811780: 1
    //                   }
    //               };
    //               $.ajax({
    //                   type: "POST",
    //                   url: "/cart/update.js",
    //                   data: shippingProtectionPayload,
    //                   dataType: 'json',
    //                   success: function (response) {
    //                       console.warn('SP Update.js',response);
    //                   }
    //               });
                  


    //           }

    //       });
    // }

    /*
     * Shipping Protection Event
     * 2020-04-23
     */
    $(document).on('click', '.shipping-protection-info', function() {

        var imageSource = $(this).attr('data-image'); //'https://cdn.shopify.com/s/files/1/0009/7684/6907/files/shinyleaf-shipping-protection.png?v=1588137929';

        if ($(window).width() < 600) {
            imageSource = $(this).attr('data-image-mobile'); //'https://cdn.shopify.com/s/files/1/0009/7684/6907/files/shinyleaf-shipping-protection-mobile.png?v=1588137929';
        }

        var outputHTML = '';
        outputHTML += '<div class="white-popup white-popup-shipping-protection">';
        outputHTML += '<img class="img-fluid" alt="Shipping Protection" title="Shipping Protection" src="' + imageSource + '">';
        outputHTML += '</div>';

        $.magnificPopup.open({
            items: {
                src: outputHTML, // can be a HTML string, jQuery object, or CSS selector
                type: 'inline'
            }
        });

    });

    $(document).on('click', '.shipping-protection-toggle', function() {
        $('.shipping-protection-checkbox').click();
    });

    $(document).on('change', '.shipping-protection-checkbox', function() {


        if ($(this).prop('checked')) {
            localStorage.setItem('shipping_protection', 'yes');
            $.post('/cart/update.js', {
                updates: {
                    33515590811780: 1,
                }
            });

            $('.shipping-protection-container').addClass('shipping-protection-on');
            setTimeout(function(){
              location.reload();
            },500);

        } else {
            localStorage.setItem('shipping_protection', 'no');
            $.post('/cart/update.js', {
                updates: {
                    33515590811780: 0,
                }
            });

            $('.shipping-protection-container').removeClass('shipping-protection-on');
            setTimeout(function(){
              location.reload();
            },500);
        }


    });


});